import React from 'react';
import {
    StyledSuggestionBoxWrapper,
    StyledHeadlineBox,
    StyledHeadline,
    StyledIconBox,
    StyledStarSvg,
    StyledLightBulbSvg,
    StyledTextBox,
} from './suggestion-box.style';
import { theme } from '../../../style/global-style';

export interface ISuggestionProps {
    type: 'suggestion' | 'exclusive';
    text: string;
    headline?: string;
}

export const SuggestionBox = ({
    type,
    text,
    headline = 'Unser Dreamlines Experten-Tipp',
}: ISuggestionProps) => {
    const content = {
        suggestion: {
            headlineBg: theme.colors['main2-20'],
            icon: <StyledLightBulbSvg />,
            iconBg: theme.colors.main2,
        },
        exclusive: {
            headlineBg: theme.colors['discountSpecial-20'],
            icon: <StyledStarSvg />,
            iconBg: theme.colors.discountSpecial,
        },
    };

    return (
        <StyledSuggestionBoxWrapper data-testid="suggestion-box">
            <StyledHeadlineBox background={content[type].headlineBg}>
                <StyledIconBox background={content[type].iconBg} type={type}>
                    {content[type].icon}
                </StyledIconBox>
                <StyledHeadline data-testid="suggestion-box-headline">{headline}</StyledHeadline>
            </StyledHeadlineBox>
            <StyledTextBox>
                <p>{text}</p>
            </StyledTextBox>
        </StyledSuggestionBoxWrapper>
    );
};
